module.exports = __webpack_public_path__ + "static/media/3560.991dd946.jpg";